import { render, staticRenderFns } from "./StockTransferForm.vue?vue&type=template&id=72bfa32a&scoped=true"
import script from "./StockTransferForm.vue?vue&type=script&lang=js"
export * from "./StockTransferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bfa32a",
  null
  
)

export default component.exports